import {createReducer, on} from '@ngrx/store';
import {clearStopManyDvrState, stopManyDvr, stopManyDvrFailure, stopManyDvrSuccess} from './dvr.stop-many.actions';


export interface State {
  record: null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const stopManyDvrReducer = createReducer(
  initialState,

  on(stopManyDvr, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(stopManyDvrSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(stopManyDvrFailure, (_state: State, action: { error: any }): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStopManyDvrState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

